import React from 'react';
import './Credentials.css';

export default function Credentials() {
  return (
    <section className="section credentials anchor" id="credentials">
      <div className="container credentials__inner">
        <div>
          <h2 className="credentials__title">Certifications & Expertise</h2>
          <ul className="credentials__list">
            <li>PMP® Certified Project Manager</li>
            <li>ITIL 4 Certified</li>
            <li>Scrum Master Certified</li>
            <li>Security+ Certified</li>
          </ul>
        </div>

        <div className="credentials__card">
          <h3>Experience Highlights</h3>
          <ul className="credentials__bullets">
            <li>7+ years of professional experience</li>
            <li>Industry experience in Banking, FinTech, and IT Services</li>
            <li>Proven track record of delivering results and solving problems fast</li>
          </ul>

          <div className="credentials__stats" aria-label="Stats">
            <div className="credentials__stat">
              <div className="credentials__statValue">7+ yrs</div>
              <div className="credentials__statLabel">Experience</div>
            </div>
            <div className="credentials__stat">
              <div className="credentials__statValue">4</div>
              <div className="credentials__statLabel">Certifications</div>
            </div>
            <div className="credentials__stat">
              <div className="credentials__statValue">2</div>
              <div className="credentials__statLabel">Core tracks</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
